import React, { useEffect, useState } from 'react'
import { Button } from '@arnsbogroup/react-voicearchive'
import useSyntheticVoice from "../../../../hooks/useSyntheticVoice";

const AiVoiceLineList = ({refetch, taskId, supplierId, aiVoiceLines}) => {

  const [syntheticVoiceState, scriptToVoice] = useSyntheticVoice();
  const [syntheticVoice, setSyntheticVoice] = useState(null);
  const [generatedVoice, setGeneratedVoice] = useState({});
  const [loaders, setLoaders] = useState({});
  const [submitLoaders, setSubmitLoaders] = useState({});

  useEffect(() => {
    getSyntheticVoice();
    generateLoaders();
  }, []);

  function generateLoaders() {
    const loaders = {};
    aiVoiceLines.forEach((aiVoiceLine) => {
      loaders[aiVoiceLine.uid] = false;
    });
    setLoaders(loaders);

    const submitLoaders = {};
    aiVoiceLines.forEach((aiVoiceLine) => {
      submitLoaders[aiVoiceLine.uid] = false;
    });
    setSubmitLoaders(submitLoaders);
  }

  function updateVoiceLine(voiceLineUid, url) {
    return fetch(`/rest/v2/aivoiceline`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        uid: voiceLineUid,
        audio_clip_url: url
      }),
    });
  }

  function getSyntheticVoice() {
    fetch(
      `/rest/v2/supplier/${supplierId}/synthetic-voice`,
      { credentials: "same-origin" }
    )
      .then((response) => response.json())
      .then((syntheticVoice) => {
        if (syntheticVoice.data.length > 0) {
          setSyntheticVoice(syntheticVoice.data[0]);
        }
      });
  }

  const onListen = (voiceLineUid) => {
    const url = generatedVoice[voiceLineUid];
    const audio = new Audio(url);
    audio.play();
  };

  const onSubmit = async (voiceLineUid) => {
    setSubmitLoaders({ ...submitLoaders, [voiceLineUid]: true });
    const response = await fetch(generatedVoice[voiceLineUid]);
    const blob = await response.blob();
    const file = new File([blob], `ai-voice-line-${voiceLineUid}.mp3`, { type: 'audio/mpeg' });

    // TODO: Only MP3 - Mono - 128 kbps is supported for now.

    const body = new FormData();
    body.append('file', file);

    const xhr = new XMLHttpRequest();
    xhr.responseType = 'json';
    xhr.onload = function(e) {
      if (this.response.success) {
        updateVoiceLine(voiceLineUid, generatedVoice[voiceLineUid]).finally(() => {
          setSubmitLoaders({ ...submitLoaders, [voiceLineUid]: false });
          setFileIdForVoiceLine(this.response.data[0].uid, voiceLineUid)
          refetch();
        });
      } else {
        setSubmitLoaders({ ...submitLoaders, [voiceLineUid]: false });
      }
    };
    xhr.open('POST', `/ordertask/handleDirectUpload?taskId=${taskId}`, true);
    xhr.send(body);
  };

  const setFileIdForVoiceLine = (fileId, voiceLineId) => {
    const data = new URLSearchParams();
    data.append('table', 'ai_voice_lines');
    data.append('field', 'file_uid');
    data.append('rowid', voiceLineId);
    data.append('val', fileId);

    fetch('/update/field', {
      method: 'POST',
      body: data
    });
  }

  const onGenerate = async (voiceLineUid) => {
    setLoaders({ ...loaders, [voiceLineUid]: true });
    const line = aiVoiceLines.find((aiVoiceLine) => aiVoiceLine.uid === voiceLineUid).line;
    const url = await scriptToVoice(syntheticVoice.elevenlabs_voice_id, line);
    setGeneratedVoice({ ...generatedVoice, [voiceLineUid]: url });
    setLoaders({ ...loaders, [voiceLineUid]: false });
  };

  return (
    <div>
      { aiVoiceLines.map((aiVoiceLine, index) => (
        <div key={`aivl${index}`} className={`px-4 py-2 text-xs font-medium my-4 shadow rounded-lg ${(aiVoiceLine.audio_clip_url) ? 'bg-green-50' : 'bg-gray-50'}`} >
          <h3>{(aiVoiceLine.audio_clip_url) ? 'Completed':'To Do'}</h3>
          <p className='p-4'>{aiVoiceLine.line}</p>
          <div className="flex space-x-2">
            <Button size="xs" icon={['fa', 'refresh']} variant="outline" disabled={loaders[aiVoiceLine.uid]} onClick={() => onGenerate(aiVoiceLine.uid)} className="flex-1">
              {loaders[aiVoiceLine.uid] ? 'Generating...' : generatedVoice.hasOwnProperty(aiVoiceLine.uid) ? 'Regenerate' : 'Generate'}
            </Button>
            <Button size="xs" icon={['fa', 'play']} variant="outline" disabled={!generatedVoice.hasOwnProperty(aiVoiceLine.uid)} onClick={() => onListen(aiVoiceLine.uid)} className="flex-1">
              Listen
            </Button>
            <Button size="xs" icon={['fa', 'save']} disabled={!generatedVoice.hasOwnProperty(aiVoiceLine.uid) || submitLoaders[aiVoiceLine.uid]} onClick={() => onSubmit(aiVoiceLine.uid)} className="flex-1">
              {submitLoaders[aiVoiceLine.uid] ? 'Uploading...' : 'Submit'}
            </Button>
          </div>
        </div>
      )) }
      { aiVoiceLines.length === 0 && <p>No AI Voice Lines</p> }
    </div>
  )
}

export default AiVoiceLineList